import { apiFetchWithStatus } from "@/lib/api";
import { VoiceOption } from "@/types/agencies";

export type VoiceVerifyResult =
  | { status: "allowed"; voice: VoiceOption }
  | { status: "missing"; voice: null }
  | { status: "unknown"; voice: null };

export async function verifyScriptVoice(
  voiceId: string | undefined
): Promise<VoiceVerifyResult> {
  if (!voiceId?.trim()) {
    return { status: "unknown", voice: null };
  }

  const response = await apiFetchWithStatus<VoiceOption>(
    `/api/voices/${encodeURIComponent(voiceId)}`
  );

  if (response.status === 404) {
    return { status: "missing", voice: null };
  }

  if (response.success && response.data?.id) {
    return { status: "allowed", voice: response.data };
  }

  return { status: "unknown", voice: null };
}
